var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bar-1",attrs:{"id":"footer-bar"}},[_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fa fa-home"}),_c('span',[_vm._v("Home")])]),_vm._t("menu-items"),_c('router-link',{attrs:{"to":"/about"}},[_c('i',{staticClass:"fa fa-cog"}),_c('span',[_vm._v("Instellingen")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }